//
//
//
//
//
//
//
//

import l from 'lang';
export default {
  data() {
    return {
      l
    };
  }
};